import React, { useState, useRef } from "react";
import { useFormikContext } from "formik";
import {
    Stack,
    Box,
    TextField,
    Chip,
    IconButton,
    InputAdornment,
    Tooltip

} from "@mui/material";
import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import { validateDateTime } from "rsuite/esm/DateInput";
import { fetchAiInsights } from "../API/backend";
import { Loader } from "../HelperFunctions/HelperFunctions";
import { useLoaderData } from "react-router-dom";

const MailComposeFeilds = () => {
    const { privileges = {}, clientID, clientName } = useLoaderData();
    const { values, setFieldValue } = useFormikContext();
    const [loading, setLoading] = useState(false);
    let timeout;

    const handleDelete = (emailToDelete) => {
        // setFieldValue(
        //     'users',
        //     values.users.filter((email) => email !== emailToDelete)
        // );
        const updatedUsers = values.users.filter((email) => email !== emailToDelete);
        const updatedUsersInfo = values.users_info.filter(
            (user) => user.email !== emailToDelete
        );
        setFieldValue('users_info', updatedUsersInfo);

        setFieldValue('users', updatedUsers);
        setFieldValue('mail_compose.to', updatedUsers);
    };

    const predefinedText = `Hello,\nI hope this email finds you well,\nPlease find attached reports.`;

    const [userText, setUserText] = useState(values.mail_compose.mail_body !== "" ? values.mail_compose.mail_body : predefinedText);

    const handleChange = (event) => {
        const inputValue = event.target.value;

        if (!inputValue.startsWith(predefinedText)) {
            setUserText(predefinedText);
            setFieldValue("mail_compose.mail_body", predefinedText);
        }
        // setUserText(inputValue);
        // setFieldValue("mail_compose.mail_body", inputValue);

        setUserText(inputValue);

        clearTimeout(timeout);
        timeout = setTimeout(() => {
            setFieldValue("mail_compose.mail_body", inputValue);
        }, 300);

    };
    const getAiInsights = async () => {
        setLoading(true);
        try {
            const corp_ids = values.selected_corporations;
            const date = new Date();
            const payload = {
                corp_ids: corp_ids,
                date,
                client_name: clientName
            }
            const insights = await fetchAiInsights(payload);
            const newText = `${predefinedText}\n\n${insights.data.insight}`;
            setUserText(newText);
            setFieldValue("mail_compose.mail_body", newText);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };
    return (
        <>
            <Stack direction={"row"} gap={2}>
                <Chip
                    label="TO"
                    variant="outlined"
                    sx={{
                        borderRadius: 1,
                        width: "70px",
                        height: "30px"
                    }}
                />

                <TextField
                    variant="standard"
                    // name="mail_compose.to"
                    // value={values.mail_compose.users}
                    fullWidth
                    placeholder="Selected Emails"
                    InputProps={{
                        readOnly: true,
                        startAdornment: (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "4px",
                                    alignItems: "center",
                                    overflow: "auto",
                                    maxHeight: "50px",
                                    minHeight: "50px",
                                    paddingY: "4px",
                                }}
                            >
                                {values.users.map((email, index) => (
                                    <Chip
                                        key={index}
                                        label={email}
                                        onDelete={() => handleDelete(email)}
                                        size="small"
                                        sx={{ fontSize: "12px", height: 24 }}
                                    />
                                ))}
                            </Box>
                        ),
                    }}
                    sx={{
                        "& .MuiInputBase-root": {
                            alignItems: "flex-start",
                        },
                        "& .MuiInputBase-input": {
                            display: "none",
                        },
                        bgcolor: "white",
                        // minHeight:"50px"

                    }}
                />


            </Stack>
            <Stack direction={"row"} gap={2}>
                <Chip
                    label="CC"

                    variant="outlined"
                    sx={{
                        borderRadius: 1,
                        width: "70px",
                        height: "30px"
                    }}
                />

                <TextField
                    variant="standard"
                    type="email"
                    name="mail_compose.cc"
                    value={values.mail_compose.cc}
                    onChange={(e) => setFieldValue("mail_compose.cc", e.target.value)}
                    sx={{
                        backgroundColor: "transparent",
                        width: "100%",
                        "& .MuiInputBase-root": {
                            fontSize: "14px"
                        },

                    }}
                />

            </Stack>
            <TextField
                variant="standard"
                placeholder="Add a subject"
                name="mail_compose.subject"
                value={values.mail_compose.subject}
                onChange={(e) => setFieldValue("mail_compose.subject", e.target.value)}

                sx={{
                    backgroundColor: "transparent",
                    width: "100%",
                    "& .MuiInputBase-root": {
                        fontSize: "14px"
                    },

                }}
            />
            <TextField
                multiline
                rows={22.3}
                variant="outlined"
                value={userText}
                onChange={handleChange}
                placeholder="Type here..."
                InputProps={{
                    style: {

                        // whiteSpace: "pre-wrap",
                        // fontFamily: "monospace",
                        // lineHeight: "10px",
                        // padding: "8px",
                    },



                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={getAiInsights}
                                size="small"
                                disableRipple
                                sx={{
                                    position: "absolute",
                                    top: "8px",
                                    right: "8px",
                                }}>
                                <Tooltip title={"AI insight generator"} arrow>
                                    <AutoFixNormalIcon sx={{ color: "gold" }} />
                                </Tooltip >
                            </IconButton>
                        </InputAdornment>
                    ),


                }}
                sx={{
                    "& .MuiInputBase-root": {
                        bgcolor: "#ffffff",
                        borderRadius: 1,
                        fontSize: "12px"
                    },
                }}
            />
            {loading && <Loader loading={loading} />}
        </>
    );
}

export default MailComposeFeilds;